import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export default function OAuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleOAuthCallback } = useAuthStore();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      return;
    }

    if (!code) {
      setError('인증 코드가 없습니다');
      return;
    }

    // OAuth 콜백 처리
    handleOAuthCallback(code)
      .then(() => {
        navigate('/lobby', { replace: true });
      })
      .catch((err) => {
        console.error('OAuth callback error:', err);
        setError(err.message || '로그인에 실패했습니다');
      });
  }, [searchParams, handleOAuthCallback, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-4">
        <div className="text-6xl mb-6">😢</div>
        <h2 className="text-xl font-semibold mb-2">로그인 실패</h2>
        <p className="text-slate-400 text-center mb-6">{error}</p>
        <button
          onClick={() => navigate('/login', { replace: true })}
          className="btn-primary"
        >
          다시 시도하기
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="w-16 h-16 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mb-6" />
      <p className="text-slate-400">로그인 처리 중...</p>
    </div>
  );
}
